// French price format on /fr (ADR 0083): Shopify renders EUR as "€35,95" in every locale; French writes "35,95 €".
// Rewrites text nodes as the parser and scripts add them, so cart drawer, quick-add and apps are covered too.
// ponytail: text-node rewrite instead of touching every `| money` call site; checkout formats fr itself.
(() => {
  if (!document.documentElement.lang.startsWith('fr')) return;
  const RE = /€(\d{1,3}(?:[ .  ]\d{3})*,\d{2})/g;
  const fix = (node) => {
    if (node.nodeType === 3) {
      if (node.nodeValue.includes('€')) {
        const v = node.nodeValue.replace(RE, '$1 €');
        if (v !== node.nodeValue) node.nodeValue = v;
      }
      return;
    }
    if (node.nodeType !== 1 || node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE') return;
    const w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    for (let t = w.nextNode(); t; t = w.nextNode()) fix(t);
  };
  new MutationObserver((ms) => {
    for (const m of ms) {
      if (m.type === 'characterData') fix(m.target);
      else m.addedNodes.forEach(fix);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('DOMContentLoaded', () => fix(document.body));
})();
